import React, { useContext } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

// const DEFAULT_BOAT_INFO = {
//   id: "00000",
//   name: "NAME",
//   imo: "",
//   mmsi: "",
//   callsign: "",
//   vesselType: "",
//   length: 0,
//   width: 0,
//   buildYear: 0,
// };

const BoatInfoContext = React.createContext();

export function useBoatInfo() {
  return useContext(BoatInfoContext);
}

export function BoatInfoProvider({ children }) {
  const [boatInfo, setBoatInfo] = useLocalStorage("boat-info", {});

  const value = {
    boatInfo,
    updateBoatInfo: setBoatInfo,
  };

  return (
    <BoatInfoContext.Provider value={value}>
      {children}
    </BoatInfoContext.Provider>
  );
}
